import React, { useState } from "react";

import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { scroller } from "react-scroll";
import Card from "react-bootstrap/Card";
import Countdown from "react-countdown";
import RangeSlider from "react-bootstrap-range-slider";

import proposingBanner from "../../assets/images/Presale.png";
import VotonLogo from "../../assets/logos/V/Logo_V_White.png";

import styles from "./CrowdPreSale.module.css";

import BlockAnimation from "./blockAnimation.jsx";

const scrollToSection = () => {
  scroller.scrollTo("homePageVotingSection", {
    //check Voting.js to find this class
    duration: 0,
    delay: 0,
    smooth: "easeInOutQuart",
  });
};

const date15M = new Date("2022-04-29 23:59:59");
const currentDate = new Date();
const startDate = new Date("2022-04-29 23:59:59")

function CrowdProposal() {
  const { height, width } = useWindowDimensions();
  const [value, setValue] = useState(0);
  return (currentDate < startDate ?
    // <div className={styles.counterSection}>
    //   <h1 className={styles.header}>BMT</h1>
    //   <div className={styles.counter} id="init_clock">
    //     <div><span class="days">%D</span> </div>
    //     <div><span class="hours">%H</span> </div>
    //     <div><span class="minutes">%M</span> </div>
    //     <div><span class="seconds">%S</span></div>


    //   </div>
    //   <h2 className={styles.article}>Under Construction.</h2>
    // </div>
    <Row className={styles.ContentContainer}>
      <Col className="d-flex align-items-center">
        <div>
          <BlockAnimation />
        </div>
      </Col>
    </Row>
    :
    <Row className={styles.ContentContainer}>
      <Col className="d-flex align-items-center">
        <div>
          <div className={styles.headerTitle}>CROWD PRE-SALE</div>
          <div className={styles.headerSubtext}>
            Participate in our Crowd Pre-Sale launch for an opportunity to buy Voton tokens at a special discounted prices and enjoy the benefits of early exclusive access.
          </div>
          <Button
            className={styles.headerButtons}
            onClick={() => scrollToSection()}
          >
            <div className={styles.headerButtonText}>Buy Now</div>
          </Button>
          <Card className={styles.cardToken}>
            <Card.Body>
              <h5 className={styles.salestext}>PRE-SALE PROGRESS</h5>
              <Card.Text className={styles.tokentext}>
                Total token&nbsp;&nbsp;<Image src={VotonLogo} width="18" height="18px" alt="voton logo" />50,000,000,000
              </Card.Text>
              <>
                <RangeSlider
                  value={20}
                  tooltipStyle={{ opacity: 0 }}
                  variant="warning"
                  onChange={(changeEvent) => setValue(changeEvent.target.value)}
                />
              </>
              <h5 className={styles.salestext}>Pre-Sale Ends</h5>
              <Countdown
                date={date15M}
                renderer={({ days, hours, minutes, seconds, completed }) => {
                  if (completed) {
                    return <div>yayyyyyyyy</div>;
                  } else {
                    return (
                      <div className={styles.timer}>
                        <div className={styles.interval}>
                          <div className={styles.timerCircle}>
                            <div className={styles.timerNumber}>{days}</div>
                          </div>
                          <div className={styles.timerIntervalText}>Days</div>
                        </div>
                        <div className={`${styles.interval} ${styles.timeIntervalSpacer}`}>
                          <div className={styles.timerCircle}>
                            <div className={styles.timerNumber}>{hours}</div>
                          </div>
                          <div className={styles.timerIntervalText}>Hours</div>
                        </div>
                        <div className={`${styles.interval} ${styles.timeIntervalSpacer}`}>
                          <div className={styles.timerCircle}>
                            <div className={styles.timerNumber}>{minutes}</div>
                          </div>
                          <div className={styles.timerIntervalText}>
                            Minutes
                          </div>
                        </div>
                        <div className={`${styles.interval} ${styles.timeIntervalSpacer}`}>
                          <div className={styles.timerCircle}>
                            <div className={styles.timerNumber}>{seconds}</div>
                          </div>
                          <div className={styles.timerIntervalText}>
                            Seconds
                          </div>
                        </div>
                      </div>
                    );
                  }
                }}
              />
            </Card.Body>
          </Card>
        </div>
      </Col>
      {width < 992 ? (
        <></>
      ) : (
        <Col style={{ textAlign: "end", position: "relative" }}>
          <Image src={proposingBanner} className={styles.votingBanner}></Image>
        </Col>
      )}
    </Row>
  );
}

export default CrowdProposal;
